// @flow

import type {CardState} from './index'

export default {
  cardFormDataById: (state: CardState) => (cardId: number) => {
    return state.formData.find(formDataItem => formDataItem.cardId === cardId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order-replacement-card/getters.js